import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorPage from '../../Shared/ErrorPage';
import CreateKnowledgeBasePage from './CreateKnowledgeBasePage.tsx';
import KnowledgeBaseDetailsPage from './KnowledgeBaseDetailsPage.tsx';
import FileDetailsPage from './FileDetailsPage.tsx';
import MultiKnowledgeBaseSearchPage from './MultiKnowledgeBaseSearch.tsx';

const VectorRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<ErrorPage />} />
      <Route path={`/add-knowledge`} element={<CreateKnowledgeBasePage />} />
      <Route path="/knowledge-base/details" element={<KnowledgeBaseDetailsPage />} />
      <Route path="/knowledge-base/file-details" element={<FileDetailsPage />} />
      <Route path="/multi-search" element={<MultiKnowledgeBaseSearchPage />} />
    </Routes>
  );
};

export default VectorRoutes;
